// extracted by mini-css-extract-plugin
export default {"form1":"LoginDetails_form1__Ry+ve","formstyle":"LoginDetails_formstyle__wxQg3"};